import { LoadingButton } from "@mui/lab"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material"
import { useContext, useEffect, useState } from "react"
import { NotificationsContext } from "../../controllers/notifications"

const TestEmailDialog = ({
  open,
  handleClose,
}: {
  open: boolean
  handleClose: () => void
}) => {
  const { currentTemplate, sendTestEmailLoading, sendTestEmail } =
    useContext(NotificationsContext)

  // email and lang
  const [email, setEmail] = useState<string>("")
  const [lang, setLang] = useState<string>("en")

  useEffect(() => {
    if (!open) {
      setEmail("")
    }
  }, [open])

  return (
    <Dialog open={open} onClose={sendTestEmailLoading ? null : handleClose}>
      <DialogTitle>Test this template</DialogTitle>
      <DialogContent style={{ minWidth: 375, overflow: "visible" }}>
        <Stack gap={2}>
          <TextField
            fullWidth
            label="Email"
            size="small"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={sendTestEmailLoading}
          />
          <FormControl
            style={{ minWidth: 110 }}
            fullWidth
            size="small"
            disabled={sendTestEmailLoading}
          >
            <InputLabel id="lang">Language</InputLabel>
            <Select
              labelId="lang"
              label="Language"
              value={lang}
              onChange={(e) => setLang(e.target.value)}
            >
              {currentTemplate.document.items.map((item) => (
                <MenuItem key={item.lang} value={item.lang}>
                  {item.lang.toUpperCase()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={sendTestEmailLoading}>
          Cancel
        </Button>
        <LoadingButton
          onClick={async () => {
            await sendTestEmail(email, lang)
            handleClose()
          }}
          loading={sendTestEmailLoading}
          disabled={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)}
        >
          Send
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default TestEmailDialog
